import Updater from './Updater';

window.newLots = [];

const Lot = {
    update: data => {
        if (window.wsDebug)
            console.log(data);

        for (var id in data) {
            if (typeof window.LOTS[id] == 'undefined')
                continue;

            if (! window.user || data[id].last_bids.indexOf(window.user) == -1)
                data[id].winner = null;
            else
                data[id].winner = (data[id].last_bids[0] == window.user);

            Updater.updateLot({lot: data[id]});
        }
    },
    create: data => {
        if (window.wsDebug)
            console.log(data);
        for (var i in data) {
            if (data[i].status == 26 && window.newLots.indexOf(data[i].bf_id) == -1 && Object.keys(window.LOTS).indexOf(data[i].bf_id) == -1)
                window.newLots.push(data[i].bf_id);
        }

        Updater.showNewLotsCounter(window.newLots.length);
    },
    delete: data => {
        if (window.wsDebug)
            console.log(data);
        for (var index in data)
            Updater.updateStatus({lot_id: data[index], status: 29});
    }
}

export default Lot;